<template>
  <div 
    
    :id="`itemexpander-${tourHubItem._id}`"
    :ref="`itemexpander-${tourHubItem._id}`"
    class="item-header item-main touring-hub-item-main"
    :class="{    
      'touring-hub-item-active': dropdown, 
      'th-alignment-standard': !tourHubItem.isStaticCard, 
      'th-alignment-leisure': tourHubItem.isStaticCard
    }"
    @click="!tourHubItem.isStaticCard? toggleExpand() : null"
  >
  
    <div 
      v-if="!tourHubItem.isStaticCard" 
      class="item-title item-end"
    />
    
    <div class="item-title text-center col-10">
      <span class="mx-auto">{{ headerTitle }}</span>
    </div>

    <div
      v-if="!tourHubItem.isStaticCard"
      class="toggle item-end"
    >
      <span v-if="!dropdown">+</span>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    tourHubItem: {
      type: Object
    },
    showAll: {
      type: Boolean
    }
  },
  data () {
    return {
      dropdown: false,
      headerTitle: '',
      
    }
  },
  watch: {
    showAll() {
      if (this.showAll === true) {
        this.dropdown = true
      } else {
        this.dropdown = false
      }
    }
  },
  mounted() {
      this.buildHeaderTitle()    
      if (this.showAll === true) { 
        this.dropdown = true
      } 
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
      this.$emit("clicked", this.dropdown);
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
    buildHeaderTitle () {
      if (this.tourHubItem.serviceType === 'Accommodation') {
        this.headerTitle = `OVERNIGHT ${this.tourHubItem.title.toUpperCase()}, ${this.tourHubItem.place.toUpperCase()}`
      } else if (this.tourHubItem.serviceType === 'Transport') {
        this.headerTitle = this.tourHubItem.title.toUpperCase()
      } else if (this.tourHubItem.serviceType.includes('at Leisure')) {
        this.headerTitle = this.tourHubItem.serviceType.toUpperCase()

      } else {
        this.headerTitle = this.tourHubItem.title.toUpperCase()
      }
    },

    
}
};
</script>

<style lang="scss">
@import "../../styles.scss";
.item-header {
  display: flex;
  align-items: center;
}
.item-end {
  width: 300px;
}
.toggle {
  display: flex;
  justify-content: flex-end;
}
.th-alignment-standard {
  justify-content: space-between;
}
.th-alignment-leisure {
  justify-content: center !important;
  text-align: center;
}
</style>